import { cn } from "../../utils/cn";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { CardBody, CardContainer, CardItem } from "./3d-card";
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { addToCart, removeFromWishlist } from "../../redux/slices/cartSlice";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addToCartThunk, removeFromWishlistThunk } from "../../thunks/thunks";
import { use } from "react";

export const HoverEffect = ({ items, className }) => {
  const dispatch = useDispatch();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  // const dispatch = useDispatch();

  const handleAddToCart = (item) => {
    dispatch(addToCartThunk({ productId: item.id, quantity: 1 }));
    dispatch(removeFromWishlistThunk(item.id));
    
    toast.success(`${item.name} added to cart and removed from wishlist!`);
    setTimeout(() => {
      window.location.reload(); // Reload the page after a delay
    }, 1000); // 2-second delay to allow the toast to display
  };

  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 py-10", className)}>
      {items.map((item, idx) => (
        console.log("item at hover effect: ",item),
        <div
          // Use a unique key
          className="relative group block p-2 h-full w-full"
          onMouseEnter={() => setHoveredIndex(idx)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <AnimatePresence>
            {hoveredIndex === idx && (
              <motion.span
                className="absolute inset-0 h-full w-full block rounded-3xl"
                layoutId="hoverBackground"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.15 } }}
                exit={{ opacity: 0, transition: { duration: 0.15, delay: 0.2 } }}
              />
            )}
          </AnimatePresence>
          <CardContainer className="inter-var">
            <CardBody className="bg-white relative group/card border-black/[0.1] w-[100%] h-[32rem] rounded-xl p-6 border shadow-md">
              <CardItem
                translateZ={20}
                as="button"
                className="px-4 py-2 rounded-xl bg-black text-white text-xs font-bold hover:text-red-500 ml-[80%]"
                onClick={() => 
                  {dispatch(removeFromWishlistThunk(item.id)) 
                  toast.success('Product removed from wishlist successfully!');
                  setTimeout(() => {
                    window.location.reload(); // Reload the page after a delay
                  }, 500); 
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </CardItem>
              <CardItem translateZ="100" className="w-full mt-4">
                <img
                  src={item.images} // Ensure this is correct; it should be the image URL
                  className="h-[20rem] w-full object-cover rounded-xl group-hover/card:shadow-xl"
                  alt={item.name}
                />
              </CardItem>
              <CardItem
                translateZ="50"
                className="text-xl font-bold text-black mt-4"
              >
                <Link
                  to={`/item/${item.id}`}
                  key={item.id} 
                >
                  {item.name}
                </Link>
                
              </CardItem>
              <CardItem className="shadow-md bg-[pink] text-white p-1 rounded-md font-bold mt-2 hover:bg-black">
                <button onClick={() => handleAddToCart(item)}>
                  Add to Cart
                </button>
              </CardItem>
            </CardBody>
          </CardContainer>
        </div>
      ))}
    </div>
  );
};

